/* import __COLOCATED_TEMPLATE__ from './basic-market-dialog.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();